import * as React from 'react';
import { get } from 'lodash';
import { Col, Grid, Row } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import * as storage from '@inqool/uas-web-core/es/utils/storage';

import {
  AutoComplete,
  AutoCompleteField,
  Date,
  DateField,
  DefaultField,
  Input,
  InputField,
  RemoteAutoComplete,
  RemoteAutoCompleteField
} from '@components/form';
import { ticketState, ticketType, paymentMethod } from '@modules/tickets/_ticketsEnums';

const View: React.SFC<any> = ({ entity }) => {
  return (
    <div>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col md={6} className="with-right-divider">
            <Row>
              <Col md={12}>
                <h4>Základní informace</h4>
              </Col>
              {[
                { name: 'seriesNumber', label: 'Číslo série', md: 4 },
                { name: 'letter', label: 'Písmeno', md: 4 },
                { name: 'number', label: 'Evidenční číslo', md: 4 },
                { name: 'value', label: 'Hodnota', type: 'number', md: 12 }
              ].map(field => (
                <Col md={field.md} key={field.name}>
                  <InputField component={Input} {...field} disabled={true} />
                </Col>
              ))}
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  name={`employee`}
                  label="Zaměstnanec"
                  url={`/metropolis/api/hr/employees`}
                  fullWidth={true}
                  labelFunction={o => get(o, 'fullName')}
                  disabled={true}
                />
              </Col>
              <Col md={12}>
                <DefaultField
                  component={AutoComplete}
                  name="state"
                  label="Stav"
                  fullWidth={true}
                  items={ticketState}
                  disabled={true}
                  labelFunction={o => get(o, 'label')}
                  valueFunction={o => get(o, 'id')}
                />
              </Col>
              <Col md={12}>
                <DefaultField
                  component={AutoComplete}
                  name="type"
                  label="Typ"
                  fullWidth={true}
                  items={ticketType}
                  disabled={
                    entity.state !== 'ISSUED' &&
                    JSON.parse(storage.get('permissions')).find(p => p === 'ROLE_DELETED_VIEW')
                  }
                  labelFunction={o => get(o, 'label')}
                  valueFunction={o => get(o, 'id')}
                />
              </Col>
              <Col md={12}>
                <AutoCompleteField
                  component={AutoComplete}
                  name="paymentMethod"
                  label="Platební metoda"
                  fullWidth={true}
                  items={paymentMethod}
                  labelFunction={o => get(o, 'label')}
                  valueFunction={o => get(o, 'id')}
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h4>Data</h4>
              </Col>
            </Row>
            {[
              { name: 'issueDate', label: 'Datum zavedení' },
              { name: 'useDate', label: 'Datum užití' },
              { name: 'collectDate', label: 'Datum zaplacení' },
              { name: 'cancelDate', label: 'Datum zrušení' },
              { name: 'demandDate', label: 'Datum vymáhaní' },
              { name: 'cashDate', label: 'Datum odevzdání' },
              { name: 'deprecationDate', label: 'Datum odpisu' }
            ].map(field => (
              <Row key={field.name}>
                <Col md={12}>
                  <DateField component={Date} name={field.name} label={field.label} disabled={true} />
                </Col>
              </Row>
            ))}
          </Col>
        </Row>

        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />
    </div>
  );
};

export const TicketsFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsFormBasic.tsx